import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-impersonate-user',
  templateUrl: './impersonate-user.component.html'
})
export class ImpersonateUserComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    const token = this.router.routerState.snapshot.root.queryParams['token'];
    this.authService.setAuthToken(token);
  }
}
